import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import {
    Button,
    StarRating,
    Text,
} from 'reaxl';

/**
 *  Displays KBB ratings inline with customizable label
 *  and optional clickable count value
 *
 */
function KBBInlineRatings({ className, rating, count, handleCountClick, label = 'Dealer' }) {
    return (
        <div className={clsx('display-flex align-items-center text-size-200 gap-1', className)}>
            <Text
                size={200}
                color="subdued"
                weight="bold"
                className="margin-right-2"
            >
                <Text>
                    KBB.com
                    <sup>&#174;</sup>
                </Text>
                {' '}
                {label}
                {' '}
                Rating
            </Text>
            <StarRating
                color="#e8bb38"
                value={rating}
                uiContext="single-star"
            />
            {!!count && (
                <Button
                    bsStyle="text"
                    onClick={handleCountClick}
                >
                    (
                    {count}
                    )
                </Button>
            )}
        </div>
    );
}

KBBInlineRatings.propTypes = {
    className: PropTypes.string,
    /**
    *   Number of ratings
    */
    count: PropTypes.number,
    /**
    *   Callback for count button
    */
    handleCountClick: PropTypes.func,
    /**
    *   Type of ratings
    */
    label: PropTypes.string,
    /**
    *   Average of ratings
    */
    rating: PropTypes.number.isRequired,
};

export default KBBInlineRatings;
